import styled from '../../../config/theme'
import { NavLink } from 'react-router-dom'
import Button from '../../Button'

const Container = styled.div<{ open: boolean }>`
  padding-top: 30px;
  width: 230px;
  min-width: 230px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 9px 0 rgba(169,184,200,.15);
  background-color: white;
  z-index: 999;

  @media screen and (max-width: ${props => props.theme.mediaQueries.menu}) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: white;
    transform: translateX(-100%);
    transition: transform .2s;

    ${props => props.open && `
      transform: translateX(0);
      transition: transform .2s;
    `}

    flex-direction: column;
    justify-content: center;

    > * {
      margin: 20px 0;
    }
  }
`

const Link = styled(NavLink)`
  font-size: 16px;
  line-height: 27px;
  padding: 12px 30px;
  background: ${props => props.theme.color.white};
  color: #9eabc0;
  margin-right: 17px;
  text-decoration: none;

  &.active {
    background: linear-gradient(to right,#3c5499,#00579b);
    color: ${props => props.theme.color.white};
    border-radius: 0 60px 60px 0;

    > img {
      filter: brightness(2);
    }
  }

  > img {
    margin-right: 8px;
    height: 20px;
    width: 20px;
  }

  &:not(.active):hover {
    color: #818181
  }
`

const Divider = styled.div`
  height: 2px;
  background: rgb(237, 242, 249);
  display: block;
  margin: 10px 0 20px 30px;
  opacity: .1;
`

const MobileToggle = styled(Button)`
  position: fixed;
  display: none;

  left: 0 !important;
  top: 0 !important;
  right: unset;
  margin: 0;
  height: 72px;
  z-index: 9999999;

  @media screen and (max-width: ${props => props.theme.mediaQueries.menu}) {
    display: unset;
  }
`

export {
  Container,
  Link,
  Divider,
  MobileToggle,
}
